module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/khb-drawing/khb-drawing.component.css
// module id = ./src/app/planning/khb-drawing/khb-drawing.component.css
// module chunks = main